<template>
  <footer>
    <span v-if="params.workOnline_copyright">版权信息：{{ params.workOnline_copyright }}</span>
    <span v-if="params.workOnline_address">线下服务区：{{ params.workOnline_address }}</span>
    <span v-if="params.workOnline_time">人工服务工作时间：{{ params.workOnline_time }}</span>
    <span v-if="params.workOnline_workDay">自助服务区工作日：{{ params.workOnline_workDay }}</span>
    <el-popover placement="top" trigger="hover" v-if="params.workOnline_wechat">
      <img :src="baseUrl + params.workOnline_wechat" alt="" width="125">
      <img slot="reference" src="../../assets/微信.png" alt="" width="16">
    </el-popover>
  </footer>
</template>

<script>
import { getConfigInfo } from '../../layout/api'
export default {
  name: 'Footer',
  data() {
    return {
      baseUrl: localStorage.getItem('baseUrl'),
      params: {
        workOnline_copyright: '',
        workOnline_address: '',
        workOnline_time: '',
        workOnline_workDay: '',
        workOnline_wechat: ''
      }
    }
  },
  async created() {
    Object.keys(this.params).forEach(async key => {
      const { data: { settingValue } } = await getConfigInfo(key)
      this.params[key] = settingValue
    })
  }
}
</script>

<style lang="scss" scoped>
footer {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 80px;
  background: #1d1d1f;
  color: #eee;
  font-size: 13px;

  span {
    white-space: nowrap;
  }
}
</style>